import getItemIdsOfConversation from 'mini-mail-list-store/lib/utils/getItemIdsOfConversation';
import getSelectedTableViewId from 'mini-mail-list-store/lib/utils/getSelectedTableViewId';
import isItemView from 'owa-mail-store/lib/utils/isItemView';
import ListViewActions from '../schema/ListViewActions';
import {
    lazyApplyConversationFlaggedState,
    lazyMarkConversationAsRead,
    lazyPinConversation,
    lazyPinItems,
    lazyApplyItemFlaggedState,
    lazyMarkItemsAsRead,
} from 'mini-mail-triage-actions';

/**
 * Determines the actions to be invoked when one of the triage options is selected
 * for a particular item on the List View of conversation view or item in item view.
 * @param actionKey is the action triggered
 * @param selectedId is the selected conversation id in conversation view or item id in item view
 */
const onListViewActionSelected = (actionKey: ListViewActions, selectedId: string) => {
    isItemView()
        ? onListViewItemActionSelected(actionKey, selectedId)
        : onListViewConversationActionSelected(actionKey, selectedId);
};

/**
 * This is executed only for actions on item in item reading pane in item view.
 */
const onListViewItemActionSelected = (actionKey: ListViewActions, itemId: string) => {
    const selectedTableViewId = getSelectedTableViewId();
    switch (actionKey) {
        case ListViewActions.MarkAsRead:
        case ListViewActions.MarkAsUnread:
            const shouldMarkAsRead = actionKey === ListViewActions.MarkAsRead;
            lazyMarkItemsAsRead({
                itemIds: [itemId],
                source: 'RPHeader',
                shouldMarkAsRead,
                tableViewId: selectedTableViewId,
            });
            break;
        case ListViewActions.Flag:
        case ListViewActions.Unflag:
            lazyApplyItemFlaggedState(
                itemId,
                actionKey === ListViewActions.Flag /* shouldMarkAsFlagged */
            );
            break;
        case ListViewActions.Pin:
        case ListViewActions.Unpin:
            lazyPinItems(
                [itemId],
                selectedTableViewId,
                actionKey === ListViewActions.Pin /* shouldMarkAsPinned */
            );
            break;
    }
};

/**
 * This is executed only for actions on conversation in conversation reading pane in conversation view.
 */
const onListViewConversationActionSelected = (
    actionKey: ListViewActions,
    conversationId: string
) => {
    const selectedTableViewId = getSelectedTableViewId();
    switch (actionKey) {
        case ListViewActions.MarkAsUnread:
        case ListViewActions.MarkAsRead:
            lazyMarkConversationAsRead(
                conversationId,
                actionKey === ListViewActions.MarkAsRead /*isUnread*/,
                selectedTableViewId
            );
            break;
        case ListViewActions.Flag:
        case ListViewActions.Unflag:
            lazyApplyConversationFlaggedState(
                conversationId,
                ListViewActions.Flag === actionKey /* shouldFlag */,
                selectedTableViewId
            );
            break;
        case ListViewActions.Pin:
        case ListViewActions.Unpin:
            lazyPinConversation(
                conversationId,
                getItemIdsOfConversation(conversationId),
                selectedTableViewId,
                ListViewActions.Pin === actionKey /* shouldMarkAsPinned */
            );
            break;
    }
};

export default onListViewActionSelected;
